// TermsOfService.js
import React from 'react';
import './TermsOfServices.css';

const TermsOfServices = () => {
  return (
    <div className="terms-container">
      <h1>Legal Terms</h1>

      <h2>Introduction</h2>
      <p>
        Welcome to WaterSprint Ltd. ("we", "our", or "us"). By accessing or using our website, digital platform, or services, you agree 
        to comply with these Terms of Service. Please read them carefully before using our site or engaging with any of our offerings, 
        including IT solutions, data science services, digital twins, and climate technology products.
      </p>
      <p>
        These Terms govern your use of the WaterSprint website and all related services. By using our platform, you acknowledge 
        that you are at least 18 years old and legally capable of entering into this agreement. If you do not agree with these Terms, 
        please do not use our services. We reserve the right to update or modify these Terms at any time, and continued use 
        constitutes acceptance of any changes.
      </p>

      <h2>User Responsibilities</h2>
      <p>You agree to use our services only for lawful purposes and in a way that does not infringe the rights of others or restrict their 
        use and enjoyment. You must not:</p>
      <ul className="bullet-list">
        <li>Attempt to gain unauthorized access to our systems or interfere with website functionality.</li>
        <li>Use our services to distribute harmful content, viruses, or spam.</li>
        <li>Misrepresent your identity or provide false information during registration or communication.</li>
      </ul>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        All content, materials, software, trademarks, logos, designs, models, and data available on this website are the exclusive 
        property of WaterSprint Ltd. or its licensors. Unauthorized use, reproduction, modification, or distribution of any material is 
        strictly prohibited without prior written consent. You may use the content only for personal or internal business purposes and 
        must retain all copyright notices when reproducing material for permitted use.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, WaterSprint Ltd. shall not be held liable for any indirect, incidental, special, or 
        consequential damages resulting from the use or inability to use our website or services, including loss of data, revenue, or 
        profits. While we strive to provide accurate and reliable information, we make no guarantees as to the completeness or 
        accuracy of the content. Your use of our services is entirely at your own risk.
      </p>
    </div>
  );
};

export default TermsOfServices;